<template>
<div class="l_stamp_history">
  <div class="container">
    <div class="content">
      <div class="months">
        <div v-for="ranking in rankings" :key="ranking.month" class="month">
          <div class="header">{{ dataFormatYyyyMm(ranking.month) }}</div>
          <div class="body">
            <div class="name">
              <span class="result"><span class="strong">{{
                    ranking.ranking.toLocaleString()
                  }}</span>位</span>
            </div>
            <div class="label">
              (対象スタンプ：{{ ranking.stamp_count }}個)
            </div>
          </div>
        </div>
      </div>
      <div class="caption">
        ※月間ランキングは、対象月の直近2ヶ月のスタンプ数を元にランキングしています。<br />※スタンプカードリセット時に引き継がれたスタンプは、累計獲得スタンプ数、月間ランキングにはカウントされません。実際に獲得した月分のみカウントされます。
      </div>
    </div>
    <div class="button">
      <UIButton label="スタンプ獲得履歴に戻る" @click="historyBack()" />
    </div>
  </div>
</div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex'
import {
  dataFormatYyyyMm
} from '../utils/StampUtil.js'
import UIButton from '@/components/UIButton'

import DateFormatter from '../utils/DateFormatter.js'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'StampHistoryMonthly',
  components: {
    UIButton
  },
  data: function () {
    return {}
  },
  computed: {
    ...mapGetters({
      rankings: 'Stamp/rankings'
    }),
    showRanking: function () {
      const tmp = []
      let count = 0
      for (var i of this.rankings) {
        count += Number(i.stamp_count)
        i.stamp_count = count
        tmp.push(i)
      }
      return tmp.reverse()
    }
  },
  created() {
    document.title = 'これまでの月間スタンプランキング'

    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.fetchStampHistory(json.app_token, accTime, json.user_id)
        window.receivedToken = null
      }
      // クーポン一覧と同じなので一旦apiTypeを3に設定する
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    dataFormatYyyyMm,
    historyBack: function () {
      this.trackEvent(FactoryTrack.createHistoryBack())
      this.$router.go(-1)
    },
    ...mapActions('Stamp', ['actionFetchStampHistory']),
    ...mapActions('Native', ['actionRequestToken']),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Analytics', ['trackEvent']),
    async fetchStampHistory(token, accTime, userId) {
      try {
        this.actionToggleLoading(true)

        await this.actionFetchStampHistory({
          token: token,
          accTime: accTime,
          userId: userId
        })
        this.mounted = true
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.errorCode = e.code
        this.isError = true
        console.error(e)
      }
      this.actionToggleLoading(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.l_stamp_history {
  width: 100%;
  min-height: 100%;
  background-color: #f6f1db;

  .content {
    background-color: var(--background-color);
    text-align: left;

    .summary {
      padding: 0 10px;
      border-radius: 5px;
      overflow: hidden;

      .item {
        margin: 10px 0;

        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        font-size: 12px;
        font-weight: bold;
        height: 40px;

        .img {
          width: 30%;
        }
      }
    }

    padding: 0 10px 0 10px;

    .months {
      .month {
        margin: 10px 0;
        border-radius: 5px;
        overflow: hidden;
        display: flex;
        width: 100%;
        height: 90px;
        justify-content: center;
        align-items: center;

        .header {
          display: flex;
          width: 140px;
          padding: 0 20px;
          height: 100%;
          justify-content: center;
          align-items: center;
          background-color: #deaa03;
          color: #ffffff;
          font-size: 16px;
          font-weight: bold;
        }

        .body {
          height: 100px;
          background-color: #ffffff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: right;
          flex: 1;
          padding: 0 20px;

          .name {
            font-size: 20px;
            font-weight: bold;
            text-align: right;
            padding: 2px 0;

            .result {
              color: #deaa08;
              text-align: right;

              .strong {
                font-size: 26px;
              }
            }
          }

          .label {
            color: #c5c5c5;
            font-weight: bold;
            text-align: right;
          }
        }
      }
    }

    .caption {
      text-align: left;
      width: 100%;

      &.right {
        text-align: right;
      }

      margin: 8px 0px;
      padding: 4px;
      font-size: 3vw;
      color: rgb(102, 102, 102);
    }
  }

  .button {
    margin: 20px 0;
    height: 40px;
    padding: 0 10px 0 10px;
    width: 100%;

    button {
      background-color: white;
      border: 1px solid #794631;
      color: #794631;
    }
  }
}
</style>
